export default __webpack_public_path__ + "static/reaction-marketing-045ffb20724a384c9f5307d11f0cfaa7.png";